import { reduce, startsWith } from 'lodash';
import { i18n } from '@lingui/core';
import { t } from '@lingui/macro';

export const MAPPINGS = {
    SYSTEM_CONFIG: 'sysConfig',
    PASSWD_CONFIG: 'passwdConfig',
    LOGIN_CONFIG: 'loginConfig',
    META: 'meta',
};

export const FIELD_MAPPINGS = {
    DEFAULT_VALIDATE_PASSWORD_COMPLEXITY: `${MAPPINGS.PASSWD_CONFIG}.validatePasswordComplexity`,
    DEFAULT_PASSWORD_MIN_LENGTH: `${MAPPINGS.PASSWD_CONFIG}.passwordMinLength`,
    DEFAULT_NUM_LOGIN_ATTEMPTS_TO_LOCK_OUT: `${MAPPINGS.LOGIN_CONFIG}.numLoginAttemptsToLockOut`,
    DEFAULT_LOCK_OUT_TIME_MINUTES: `${MAPPINGS.LOGIN_CONFIG}.lockOutTimeMinutes`,

    VALIDATE_PASSWORD_COMPLEXITY: `${MAPPINGS.SYSTEM_CONFIG}.validatePasswordComplexity`,
    PASSWORD_MIN_LENGTH: `${MAPPINGS.SYSTEM_CONFIG}.passwordMinLength`,

    NUM_LOGIN_ATTEMPTS_TO_LOCK_OUT: `${MAPPINGS.SYSTEM_CONFIG}.numLoginAttemptsToLockOut`,
    LOCK_OUT_TIME_MINUTES: `${MAPPINGS.SYSTEM_CONFIG}.lockOutTimeMinutes`,
    SYSTEM_TIMEOUT: `${MAPPINGS.SYSTEM_CONFIG}.systemTimeout`,
    SYSTEM_TIMEOUT_MINUTES: `${MAPPINGS.SYSTEM_CONFIG}.systemTimeoutMinutes`,
    CHECK_USER_INACTIVITY: `${MAPPINGS.SYSTEM_CONFIG}.checkUserInactivity`,
    DISABLE_AFTER_DAYS_INACTIVE: `${MAPPINGS.SYSTEM_CONFIG}.disableAfterDaysInactive`,

    SMTP: `${MAPPINGS.SYSTEM_CONFIG}.smtp`,
    SMTP_USERNAME: `${MAPPINGS.SYSTEM_CONFIG}.smtp.userName.value`,
    SMTP_PASSWORD: `${MAPPINGS.SYSTEM_CONFIG}.smtp.password.value`,
    SMTP_SERVER: `${MAPPINGS.SYSTEM_CONFIG}.smtp.hostName`,
    SMTP_PORT: `${MAPPINGS.SYSTEM_CONFIG}.smtp.hostPort`,
    SMTP_SEND_EMAIL: `${MAPPINGS.SYSTEM_CONFIG}.smtp.from`,
    SMTP_USE_SSL: `${MAPPINGS.SYSTEM_CONFIG}.smtp.useSsl`, // Deprecated for 3.9 onwards
    SMTP_NO_CERTS: `${MAPPINGS.SYSTEM_CONFIG}.smtp.disableServerCertVerification`,
    SMTP_HEADER_NAME: `${MAPPINGS.SYSTEM_CONFIG}.smtp.smtpHeaders.0.name`,
    SMTP_HEADER_VALUE: `${MAPPINGS.SYSTEM_CONFIG}.smtp.smtpHeaders.0.value`,
    SMTP_SECURITY: `${MAPPINGS.SYSTEM_CONFIG}.smtp.security`, // Will be one of "None", "TLS", or "STARTTLS"

    SNMP_ENGINE_ID: `${MAPPINGS.SYSTEM_CONFIG}.snmpEngineId`,
    PORTAL_LOCATION: `${MAPPINGS.SYSTEM_CONFIG}.portalLocation`,

    DISABLE_IPM: `${MAPPINGS.SYSTEM_CONFIG}.disabledIPM`,
    MERIDIEM_TIME_FORMAT: `${MAPPINGS.SYSTEM_CONFIG}.notificationMeridiemTimeFormat`,

    ALLOW_GEOJSON_OVERLAY: `${MAPPINGS.SYSTEM_CONFIG}.allowMapOverlay`,

    GEOJSON_FILE: `${MAPPINGS.SYSTEM_CONFIG}.geoJsonFile`,
    GEOJSON_FILENAME: `${MAPPINGS.SYSTEM_CONFIG}.geoJsonFileName`,

    NG1_URL: `${MAPPINGS.SYSTEM_CONFIG}.nG1Configuration.ng1.url`,
    NG1_PRE_SHARED_KEY: `${MAPPINGS.SYSTEM_CONFIG}.nG1Configuration.ng1.preSharedKey.value`,
    NG1_DISABLE_CERT_CHECK: `${MAPPINGS.SYSTEM_CONFIG}.nG1Configuration.ng1.disableCertificateCheck`,
    NG1_ASSIGNED_SERVER_ID: `${MAPPINGS.SYSTEM_CONFIG}.nG1Configuration.ng1.assignedServerId`,
};

export const VALIDATION_FIELD_MAPPINGS = reduce(
    FIELD_MAPPINGS,
    (acc, formField) => {
        if (startsWith(formField, `${MAPPINGS.SYSTEM_CONFIG}.`)) {
            const apiField = formField.substring(MAPPINGS.SYSTEM_CONFIG.length + 1);
            acc[apiField] = formField;
        } else {
            acc[formField] = formField;
        }

        return acc;
    },
    {}
);

export const META_FIELD_MAPPINGS = {
    SMTP_ENABLED: `${MAPPINGS.META}.smtpEnabled`,
    SMTP_TEST_EMAIL: `${MAPPINGS.META}.smtpTestEmail`,
    GEOJSON_FILENAME: `${MAPPINGS.META}.geoJsonFileName`,
    GEOJSON_FILE: `${MAPPINGS.META}.geoJsonFile`,
};

export const AGENT_SOFTWARE_VERSION = {
    BREAKING_MAJOR_VERSION: 'breakingMajorVersion',
    BREAKING_MINOR_VERSION: 'breakingMinorVersion',
    BREAKING_VERSION: 'breakingVersion',
    PLATFORM_VERSION: 'platformVersion',
    SOFTWARE_MAJOR_VERSION: 'softwareMajorVersion',
    SOFTWARE_MINOR_VERSION: 'softwareMinorVersion',
    VERSION_STRING: 'versionString',
};

const WIRELESS = 'wireless';
const WIRED = 'wired';
const DEFAULT = 'default';
export const MULTI = 'multi';

// identifies the only valid service test interfaces values
export const SERVICE_TEST_INTERFACES = { WIRELESS, DEFAULT };

export const SERVICE_TEST_INTERFACE_TOOLTIP_LOOKUP = {
    [WIRELESS]: i18n._(
        t`nPoint is registered with its wireless interface. All VoIP traffic will go through this interface`
    ),
    [DEFAULT]: i18n._(
        t`nPoint is registered with its wired interface. All VoIP traffic will go through this interface. For virtual nPoints, this is the host's default interface`
    ),
};

export const SERVICE_TEST_INTERFACE_LOOKUP = {
    [WIRED]: i18n._(t`Wired`),
    [WIRELESS]: i18n._(t`Wireless`),
    [DEFAULT]: i18n._(t`Wired`),
    [MULTI]: i18n._(t`Wireless (Part of a Wi-Fi Group Test)`),
};

export const EMAIL_SEPARATOR = ';';
